export default "__VITE_ASSET__4f99373b__"